module.exports = __webpack_public_path__ + "static/instagram_white-11611117fdbdc5bab796ad4f281b5ef9.png";